import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { CartProvider } from './context/CartContext';
import { RegionProvider } from './context/RegionContext';
import { Navbar } from './components/Navbar';
import { RegionWelcome } from './components/RegionWelcome';
import { Footer } from './components/Footer';
import { SplashScreen } from './components/SplashScreen';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import StorePage from './pages/StorePage';
import ContactPage from './pages/ContactPage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import AdminPage from './pages/AdminPage';
import SuccessPage from './pages/SuccessPage';
import CancelPage from './pages/CancelPage';
import TrackOrderPage from './pages/TrackOrderPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

/**
 * Layout principal — envuelve las páginas con Navbar + Footer.
 * RegionProvider (en App) ya está disponible aquí.
 */
function Layout() {
  const location = useLocation();
  const isAdmin  = location.pathname.startsWith('/admin');
  const isStripe = /^\/(mx|us)\/(success|cancel)$/.test(location.pathname)
                || location.pathname === '/success'
                || location.pathname === '/cancel';

  if (isAdmin) return (
    <Routes>
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );

  if (isStripe) return (
    <Routes>
      <Route path="/success"          element={<SuccessPage />} />
      <Route path="/cancel"           element={<CancelPage />} />
      <Route path="/:region/success"  element={<SuccessPage />} />
      <Route path="/:region/cancel"   element={<CancelPage />} />
    </Routes>
  );

  return (
    <>
      <RegionWelcome />
      <Navbar />
      <main>
        <Routes>
          {/* Redirige raíz → región por defecto */}
          <Route path="/" element={<Navigate to="/mx" replace />} />

          {/* Rutas regionales — /:region/* */}
          <Route path="/:region"             element={<HomePage />} />
          <Route path="/:region/about"       element={<AboutPage />} />
          <Route path="/:region/store"       element={<StorePage />} />
          <Route path="/:region/contact"     element={<ContactPage />} />
          <Route path="/:region/product/:id" element={<ProductPage />} />
          <Route path="/:region/cart"        element={<CartPage />} />
          <Route path="/:region/success"     element={<SuccessPage />} />
          <Route path="/:region/cancel"      element={<CancelPage />} />

          {/* Rutas globales (sin región) */}
          <Route path="/track"          element={<TrackOrderPage />} />
          <Route path="/terms"          element={<TermsPage />} />
          <Route path="/privacy"        element={<PrivacyPage />} />
          <Route path="/:region/track"  element={<TrackOrderPage />} />
          <Route path="/:region/terms"  element={<TermsPage />} />
          <Route path="/:region/privacy" element={<PrivacyPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [ready, setReady] = useState(false);
  const handleDone = useCallback(() => setReady(true), []);

  return (
    <>
      {!ready && <SplashScreen onDone={handleDone} />}
      <LanguageProvider>
        <CartProvider>
          <BrowserRouter>
            {/* RegionProvider lee la URL — debe estar dentro de BrowserRouter */}
            <RegionProvider>
              <Layout />
            </RegionProvider>
          </BrowserRouter>
        </CartProvider>
      </LanguageProvider>
    </>
  );
}

export default App;


